import ClientGeneralForm from './ClientGeneralForm'

export * from './ClientGeneralForm'
export * from './UploadCompanyLogo'
export default ClientGeneralForm
